import { GET_PATIENT_GRAPH_SUCCESS } from "../actions/patientAction";


const initialState = {
    tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} ({d}%)'
    },
    legend: {
        orient: 'vertical',
        right: 50,
        top: 50,
        icon: "circle",
        data: ['Xray Scan', 'CT Scan', 'MRI Scan']
    },
    series: [
        {
            color: ['#15A9E1', '#73D8FF', '#075087'],
            name: 'Utilization',
            type: 'pie',
            avoidLabelOverlap: false,
            label: {
                show: false,
                position: 'center'
            },
            emphasis: {
                label: {
                    show: true,
                    fontSize: '30',
                    fontWeight: 'bold'
                }
            },
            labelLine: {
                show: false
            },
            data: [
                {value: 335, name: 'Xray Scan'},
                {value: 310, name: 'CT Scan'},
                {value: 234, name: 'MRI Scan'},
            ]
        }
    ]
};

  const patientRecordGraph = (state = initialState, { type }) => {
    switch (type) {
      case GET_PATIENT_GRAPH_SUCCESS:
        return state
      default:
        return state
    }
  }

  export default patientRecordGraph